import { Descriptions } from 'antd';

export const ChangesModalBody = ({ data }) => {
  const rawChanges = data?.changes;

  const getChanges = () => {
    if (!rawChanges) return {};
    if (typeof rawChanges === 'object') return rawChanges;

    try {
      return JSON.parse(rawChanges);
    } catch {
      return {};
    }
  };

  const changes = getChanges();

  const changesLabels = {
    reason: 'Razón',
    type: 'Tipo',
    cabainId: 'Cabina',
    branchId: 'Sucursal',
    recurrent: 'Recurrente',
    date: 'Fecha de bloqueo',
  };

  return (
    <Descriptions bordered column={1} size="middle">
      {Object.entries(changes).map(([key, value]) => (
        <Descriptions.Item key={key} label={changesLabels[key] || key}>
          {String(value)}
        </Descriptions.Item>
      ))}
      <Descriptions.Item label="Navegador">
        {data?.metadata || '-'}
      </Descriptions.Item>
    </Descriptions>
  );
};
